import { QuoteFilterOptions } from '~/lib/quotes';
import { QuoteFilterCheckbox } from './quote-filter-section';
import { P2GBox } from '@parcel2go/core-ui';

export default function CollectionRequired({
  filter,
  onChange,
  label
}: {
  label: string;
  filter: QuoteFilterOptions;
  onChange: (filter: QuoteFilterOptions) => void;
}) {
  const isSelected = !!filter.serviceType?.includes('Collection');
  return (
    <P2GBox style={{ opacity: filter.serviceType !== 'Drop Off' ? 1 : 0.3, transition: 'opacity 0.5s' }}>
      <QuoteFilterCheckbox
        disable={false}
        isSelected={isSelected}
        onClick={() => {
          onChange({
            ...filter,
            serviceType: isSelected ? undefined : 'Collection'
          });
        }}
        label={label}
      />
    </P2GBox>
  );
}
